import React from 'react';
import { IIconProps } from '../interfaces';

const CreditCardIcon = (props: IIconProps) => {

    return (
        <svg width="25" height="18" viewBox="0 0 25 18" xmlns="http://www.w3.org/2000/svg"><g fill={ props.color } stroke="#ECF5FF" fillRule="evenodd"><path d="M21.7 1H3.3C2.03 1 1 2.007 1 3.25v11.5C1 15.993 2.03 17 3.3 17h18.4c1.27 0 2.3-1.007 2.3-2.25V3.25C24 2.007 22.97 1 21.7 1zM3.3 2.25h18.4c.271 0 .531.105.723.293a.99.99 0 0 1 .3.707v1.875H2.276V3.25c0-.553.459-1 1.023-1zm18.4 13.5H3.3a1.012 1.012 0 0 1-1.022-1V6.375h20.445v8.375c0 .265-.108.52-.3.708a1.037 1.037 0 0 1-.723.292z" strokeWidth=".3"/><path d="M5.36 9.8h5.52c.29 0 .525.353.525.64v.32c0 .353-.235.64-.526.64H5.36c-.29 0-.525-.353-.525-.64v-.32c0-.353.236-.64.526-.64zm7.737 0h2.274c.28 0 .506.353.506.64v.32c0 .353-.227.64-.506.64h-2.274c-.28 0-.506-.353-.506-.64v-.32c0-.353.227-.64.506-.64z" strokeWidth=".5"/></g></svg>
    )
};

export default CreditCardIcon;
